import {
  Grid2 as Grid,
  Chip,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import React, { useState } from "react";
import CustomChatbot from "../components/CustomChatbot";
import { useNavigate } from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "@mui/material";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import { KeyboardBackspace, ExpandMore } from "@mui/icons-material";
import { notificationResponses } from "../assets/notificationResponse";
import NotiCard from "../components/NotiCard";

const Notifications = () => {
  const navigate = useNavigate();
  const { need_to_do, need_to_know, good_to_know } = notificationResponses;
  
  return (
    <Grid container>
      <Grid size={8} pl={3} pt={3} pr={2}>
        <Grid
          container
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <IconButton sx={{ color: "#00555C" }} onClick={() => navigate(-1)}>
            <KeyboardBackspace />
            <span className="text-sm"> Back</span>
          </IconButton>
          <div>
            {/* <Chip
              label="Client Metric Hub"
              clickable
              onClick={() => navigate("/clientInsights")}
              sx={{
                fontWeight: "600",
                fontSize: "10px",
                height: "24px",
                minWidth: "150px",
                backgroundColor: "#00555C",
                color: "#fff",
              }}
            /> */}
          </div>
        </Grid>
        <div style={{ height: "80vh", overflowY: "auto" }}>
          <Grid m={2} container>
            <Grid item size={12}>
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <div className="flex items-center gap-2">
                    <AssignmentOutlinedIcon className="text-main" />
                    <h2 className="text-xs font-bold text-main">NEED TO DO</h2>
                    <Tooltip
                      title="Important tasks that require your attention"
                      arrow
                    >
                      <InfoOutlinedIcon className="text-main" fontSize="4px" />
                    </Tooltip>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <NotiCard data={need_to_do} />
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item size={12} pt={2}>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <div className="flex items-center gap-2">
                    <MenuBookOutlinedIcon className="text-main" />
                    <h2 className="text-xs font-bold text-main">
                      NEED TO KNOW
                    </h2>
                    <Tooltip
                      title="Important updates related to your client"
                      arrow
                    >
                      <InfoOutlinedIcon
                        className="ml-2 text-main"
                        fontSize="4px"
                      />
                    </Tooltip>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <NotiCard data={need_to_know} />
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item size={12} pt={2}>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <div className="flex items-center gap-2">
                    <TipsAndUpdatesOutlinedIcon className="text-main" />
                    <h2 className="text-xs font-bold text-main">
                      GOOD TO KNOW
                    </h2>
                    <Tooltip
                      title="Relevant insights or market trends that may benefit your clients"
                      arrow
                    >
                      <InfoOutlinedIcon
                        className="ml-2 text-main"
                        fontSize="4px"
                      />
                    </Tooltip>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <NotiCard data={good_to_know} />
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        </div>
      </Grid>

      <Grid size={4} pt={1}>
        <CustomChatbot height={"83vh"} selectedTab={"notification"} />
      </Grid>
    </Grid>
  );
};

export default Notifications;
